export const TRIGGER_PREFIX_ABOVE = '>'
export const TRIGGER_PREFIX_BELOW = '<'

export const TOAST_AUTO_CLOSE_TIME = 7000000
export const WS_LOST_FOCUS_TIMEOUT = 1000 * 60

export const PERCENTAGE_SUGGESTIONS = [10, 25, 50, 75, 100]
export const MAX_METAMASK_MOBILE_DECIMALS = 5
export const INPUT_LABEL_SEPARATOR = ':'
